import { render, staticRenderFns } from "./dynamicModalTables.vue?vue&type=template&id=381ccf3c&scoped=true"
import script from "./dynamicModalTables.vue?vue&type=script&lang=js"
export * from "./dynamicModalTables.vue?vue&type=script&lang=js"
import style0 from "./dynamicModalTables.vue?vue&type=style&index=0&id=381ccf3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381ccf3c",
  null
  
)

export default component.exports